<template>
	<v-list dense rounded v-if="data">
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					:rules="[(v) => !!v || 'Title is mandatory']"
					class="fullwidth"
					filled
					label="Title"
					prepend-icon="mdi-identifier"
					required
					v-model="data.title"
				></v-text-field>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<h3 class="mb-4">
					<v-icon left>mdi-attachment</v-icon> File Attachments
				</h3>
				<Collection
					cols="auto"
					:collection="data.files"
					@change="dataChanged = true"
					dialogWidth="600"
					:form="$options.FileForm"
					title="File Attachment"
					breakpoints="xs12 sm3 md3 lg3 xl2"
					isFileUpload
					hideHelp
				>
					<FileItem slot-scope="{ item }" v-bind="item" />
				</Collection>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<h3 class="mb-2"><v-icon left>mdi-text-subject</v-icon> Content</h3>
				<TextEditor v-model="data.text" style="height: 300px" />
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'
import Collection from '@/components/admin/ItemCollection'

import Messages from '@/helpers/message-helper'
import FileItem from '@/components/n-collections/n-items/FileItem'

import FileForm from './FileForm'
import FileService from '@/services/FileService'

export default {
	name: 'NewsForm',
	FileForm,
	components: {
		TextEditor,
		Collection,
		FileItem
	},
	props: {
		data: {
			type: Object,
			default: {
				title: '',
				files: [],
				text: '',
			},
		},
	},
	methods: {
		async uploadFile(file) {
			if (file) {
				const { name } = file
				const result = await FileService.uploadS3(name, file)
				if (result) this.$set(this.data, 'icon', result.path)
			}
		},
	},
}
</script>
